import '../styles/RequestBillListStyle.css';
import { useState } from 'react';
import { BaseInput, RequestedBill } from '../common';
import { useTypedSelector } from '../../hooks';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Batu } from '../../batu/interface/Batu';

const RequestedBillList: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortList, setSortList] = useState(true);
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortVariable, setSortVariable] = useState('');
  const requestedBills = useTypedSelector(({ bills }) => {
    return bills.requestedBills;
  });
  const filteredBills = requestedBills.filter((bill) =>
    bill.rpu.includes(searchTerm.toLowerCase())
  );
  const renderBillList = () => {
    if (sortList) {
      const sortedBills = filteredBills.sort((a, b) => {
        // Replace 'variableElement' with the actual property you want to sort by
        const variableElementA = a[sortVariable as keyof Batu];
        const variableElementB = b[sortVariable as keyof Batu];
        if (variableElementA && variableElementB) {
          if (
            typeof variableElementA === 'string' &&
            typeof variableElementB === 'string'
          ) {
            if (sortOrder === 'asc') {
              return variableElementA.localeCompare(variableElementB);
            }
            return variableElementB.localeCompare(variableElementA);
          }
          if (
            typeof variableElementA === 'number' &&
            typeof variableElementB === 'number'
          ) {
            if (sortOrder === 'asc') {
              return variableElementA - variableElementB;
            }
            return variableElementB - variableElementA;
          }
          if (
            sortVariable === 'datetime' &&
            typeof variableElementA === 'object' &&
            typeof variableElementB === 'object'
          ) {
            if (sortOrder === 'asc') {
              return variableElementA.getTime() - variableElementB.getTime();
            }
            return variableElementB.getTime() - variableElementA.getTime();
          }
        }
        return 0;
      });
      return (
        <>
          {sortedBills.map((batuBill) => {
            return <RequestedBill key={batuBill.id} batu={batuBill} />;
          })}
        </>
      );
    }
    return (
      <>
        {filteredBills.map((batuBill) => {
          return <RequestedBill key={batuBill.id} batu={batuBill} />;
        })}
      </>
    );
  };
  const changeSorting = (_sortVariable: string) => {
    if (_sortVariable === sortVariable) {
      if (!sortList) {
        setSortOrder('asc');
        setSortList(true);
      } else {
        if (sortOrder === 'asc') {
          setSortOrder('desc');
        }
        if (sortOrder === 'desc') {
          setSortList(false);
        }
      }
    } else {
      setSortVariable(_sortVariable);
      setSortOrder('asc');
      setSortList(true);
    }
  };
  const renderSortArrow = (variable: string) => {
    if (!sortList || variable !== sortVariable) {
      return <FaSort className="requested-bill-table-sort-icon" />;
    }
    if (sortOrder === 'asc') {
      return <FaSortUp className="requested-bill-table-sort-icon active" />;
    }
    return <FaSortDown className="requested-bill-table-sort-icon active" />;
  };
  return (
    <div className="requested-bill-list">
      <BaseInput
        inputLabel=""
        extraClassContainer="requested-bill-filter"
        val={searchTerm}
        inputPlaceholder="Filtrar RPU"
        inError={false}
        onTextChange={(val) => {
          setSearchTerm(val);
        }}
      />
      <table className="requested-bill-table">
        <thead className="requested-bill-table-header">
          <tr className="requested-bill-table-item">
            <th className="requested-bill-table-item one"></th>
            <th
              className="requested-bill-table-item two"
              onClick={() => {
                changeSorting('rpu');
              }}
            >
              {renderSortArrow('rpu')}RPU
            </th>
            <th
              className="requested-bill-table-item four"
              onClick={() => {
                changeSorting('progress');
              }}
            >
              {renderSortArrow('progress')}Estatus
            </th>
            <th
              className="requested-bill-table-item three date"
              onClick={() => {
                changeSorting('datetime');
              }}
            >
              {renderSortArrow('datetime')}Fecha
            </th>
            <th className="requested-bill-table-item one">Acciones</th>
          </tr>
        </thead>
        <tbody className="requested-bill-table-body">{renderBillList()}</tbody>
      </table>
    </div>
  );
};
export { RequestedBillList };
